import { TableSortOrder } from "../../../../interfaces";

const descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {

  if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string') {
    const astring: string = a[orderBy] as string
    const bstring: string = b[orderBy] as string

    if (astring.toLowerCase() < bstring.toLowerCase()) return -1
    if (astring.toLowerCase() > bstring.toLowerCase()) return 1
    return 0
  }

	if (b[orderBy] < a[orderBy]) return -1
	if (b[orderBy] > a[orderBy]) return 1

	return 0;
}

export const getComparator = <Key extends keyof any>(order: TableSortOrder, orderBy: Key)
	: (a: { [key in Key]: number | string | null | undefined }, b: { [key in Key]: number | string | null | undefined })
	=> number => {
	const innerComparator = order === TableSortOrder.Descending
		? (a: any, b: any) => descendingComparator(a, b, orderBy)
		: (a: any, b: any) => -descendingComparator(a, b, orderBy);

	return (a, b) => {
		const aVal = a[orderBy];
		const bVal = b[orderBy];
		if (aVal == null && bVal == null) return 0;
		if (aVal == null) return order === TableSortOrder.Ascending ? 1 : -1;
		if (bVal == null) return order === TableSortOrder.Ascending ? -1 : 1;
		return innerComparator(a, b);
	};
};
